import type {Variants} from 'motion';

export const ModalEnterExitAnimation: Variants = {
    enter: {
        opacity: 1,
        y: '0px'
    },
    exit: {
        opacity: 0,
        y: '80px'
    }
};